/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { hostingHandOffblack } from "../assets/hosting-hand-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconHostingHandOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={hostingHandOffblack.svg} />
);

IllustrativeIconHostingHandOffblack.displayName = "IllustrativeIconHostingHandOffblack";
